import api from "./api";

// Capa de servicios API del dominio "campaign-shipping-reports" (reportes de envío de campañas).
export const getCampaignShippingEstimations = (campaignId) =>
  api.get(`/campaign-shipping-reports/estimations/${campaignId}`);
export const getCampaignShippingDetail = (params) =>
  api.get("/campaign-shipping-reports/detail", { params });
export const getCampaignShippingMetrics = (params) =>
  api.get("/campaign-shipping-reports/metrics", { params });
